module.exports = __webpack_public_path__ + "img/sdg3_id.45126571.svg";